import images from '@assets/images/index'
import { Module } from 'src/types/type'

import { Entities_Modules_SlugLink } from '@suntex.fim/api-client'

import {
  getModuleDisplayName,
  getModuleUrl,
  parseModuleReference
} from './moduleDisplayName'

interface CheckboxItemProps {
  label: string
  checkedModulesAndClusters: {
    [key: string]: boolean
  }
  handleCheckboxChange: (name: string) => void
  name: string
  selectedModule: Module
  slugLinks: Entities_Modules_SlugLink[]
}

function CheckboxItem({
  label,
  checkedModulesAndClusters,
  handleCheckboxChange,
  name,
  selectedModule,
  slugLinks
}: CheckboxItemProps) {
  let modifyName
  if (name) {
    if (name.includes('\n')) {
      modifyName = ''
    } else {
      modifyName = `-${name}`
    }
  } else {
    modifyName = ''
  }
  let displayName = label
  let moduleUrl = ''
  const moduleReference = parseModuleReference(label)
  const matchingItem = slugLinks.find(
    (item) => item.slug === moduleReference.slug.toLowerCase()
  )
  let text = `${label} Module not found`
  if (matchingItem) {
    // Use the original module URL for Hub-style navigation (same as UIUtil.navigate)
    moduleUrl = getModuleUrl(matchingItem.urlNew.urlPreview || '', {
      moduleVariant: moduleReference.variant
    })
    text = `${matchingItem.text}`
  }

  const handleModuleClick = () => {
    if (moduleUrl) {
      // Legacy modules render Adobe Animate/createjs canvases that need a
      // full page reload rather than client-side routing.
      window.location.href = moduleUrl
    }
  }

  displayName =
    moduleReference.variantName ||
    getModuleDisplayName(text, moduleReference.slug.toLowerCase())
  // Create a unique ID by combining name and label
  const uniqueId = `Module-${selectedModule.module}${modifyName}:${label}`
  return (
    <li className="sub-card-item__checkbox-group-item">
      <div className="item__chkbox">
        <div className="pretty p-icon p-toggle">
          <input
            type="checkbox"
            checked={checkedModulesAndClusters[uniqueId] || false}
            onChange={() => handleCheckboxChange(uniqueId)}
          />
          <div className="state p-on">
            <images.CheckboxCheckedLg />
          </div>
          <div className="state p-off">
            <images.CheckboxEmptyLg />
          </div>
        </div>
      </div>
      <div className="item__label">
        <li key={displayName}>
          <div
            onClick={handleModuleClick}
            className="text-primary-hover"
            style={{ cursor: 'pointer' }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleModuleClick()
              }
            }}
          >
            {displayName}
          </div>
        </li>
      </div>
    </li>
  )
}

export default CheckboxItem
